import { jwtDecode } from "jwt-decode";
export function decodeAuthToken(token: string) {
  try {
    const decoded: any = jwtDecode(token);

    const user_id = decoded.id;
    const role = decoded.role;
    const username = decoded.username;
    const company = decoded.company;
    const company_id = decoded.company_id;
    sessionStorage.setItem("user_id", user_id);
    sessionStorage.setItem("role", role);
    sessionStorage.setItem("username", username);
    sessionStorage.setItem("company", company);
    sessionStorage.setItem("company_id", company_id);

  } catch (error) {
    console.error("Error decoding token:", error);
    throw error;
  }
}
